import { observer } from 'mobx-react';

import { TOP_PAGE_THEME_TYPE, USER_TYPE } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import NotFoundScreen from '../404/NotFoundScreen';
import GAHomeScreen from './GAHomeScreen';
import STDHomeScreen from './STDHomeScreen';
import STDHomeScreenNew from './STDHomeScreenNew/STDHomeScreenNew';
import TopPageScreenNew from './TopPageScreenNew/TopPageScreenNew';


const HomeScreen = observer(({ typeTheme }) => {
    // store
    const {
        authStore: { token, userInfo }
    } = useStore();

    if (typeTheme === TOP_PAGE_THEME_TYPE.PREVIEW || !token) {
        return <TopPageScreenNew typeTheme={typeTheme} />;
    }

    if (userInfo?.roleId === USER_TYPE.GROUP_MANAGER) {
        return <GAHomeScreen />
    }

    if (userInfo?.roleId === USER_TYPE.STUDENT_GROUP || userInfo?.roleId === USER_TYPE.STUDENT_INDIVIDUAL) {
        return <STDHomeScreenNew />;
    }

    return <NotFoundScreen />;
});

export default HomeScreen;
